import { LANGUAGES } from '@grafana/i18n';
import { type LocaleFileLoader } from 'app/core/internationalization/constants';

export const ENTERPRISE_I18N_NAMESPACE = 'grafana-enterprise';

export const LOCALE_EXTENSIONS: Record<string, LocaleFileLoader> = LANGUAGES.reduce<Record<string, LocaleFileLoader>>(
  (acc, { code }) => {
    acc[code] = () => import(`./${code}/grafana-enterprise.json`);
    return acc;
  },
  {}
);
